<script>
import { generateHorizontalStackedBarChartLtr } from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart-ltr";
import { generateHorizontalStackedBarChart } from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart";
import {debounce} from "lodash";

export default {
  name: "HorizontalStackedBarChart",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Object,
      default: () => ({}),
    },
    customGroupSorting: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    rightToLeft: {
      type: Boolean,
      default: false,
    },
    translateSubGroup: {
      type: Boolean,
      default: true,
    },
    parentHeight: {
      type: Boolean,
    },
  },
  watch: {
    chartData: function () {
      this.drawChart();
    },
    "$i18n.locale": function (locale) {
      this.drawChart();
    },
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart:    function () {
      this.$refs.container.firstChild?.remove();
      // Append the SVG element.
      var width = this.$refs.container.getBoundingClientRect().width ?? 0;
      var height = this.parentHeight
        ? this.$refs.container.parentElement?.getBoundingClientRect().height ?? 0
        : this.config.height;

      var node = this.rightToLeft
        ? generateHorizontalStackedBarChartLtr(
            this.chartData,
            this.colors,
            { ...this.config, width, height },
            this.customGroupSorting,
            this.translateSubGroup
          )
        : generateHorizontalStackedBarChart(
            this.chartData,
            this.colors,
            { ...this.config, width, height },
            this.customGroupSorting,
            this.translateSubGroup
          );

      if (node !== null) {
        this.$refs.container.append(node);
      }
    }
  },
};
</script>

<template>
  <div ref="container" class="horizontal-stacked-bar-chart-svg" />
</template>

<style>
.horizontal-stacked-bar-chart-axis {
  font-style: normal;
  font-weight: normal;
  font-family: Montserrat, sans-serif;

  color: #0a0a0a;
}

.horizontal-stacked-bar-chart-percentage {
  font-family: Montserrat, sans-serif;
  fill: #2f60a6;
}

.horizontal-stacked-bar-chart-tooltip {
  background-color: #ffffff;
  box-shadow: 0 3px 6px #00000029;
  padding: 6px 3px;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  z-index: 9999;
  color: #322c2e;
}

.horizontal-stacked-bar-chart-svg {
  flex-grow: 1;

  svg {
    width: 100%;
  }
}
</style>
